import { all, call, delay, put, takeLatest, select } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
	LOGIN_ACTION,
	LOGOUT_ACTION,
	FORGOT_PASSWORD,
	UPDATE_JWT_TOKEN,
	SAVEFILTER,
	DELETE_FILTERS,
	getUserSuccess,
	getFiltersSuccess,
	logoutSuccess,
	LOAD_USER,
	setAuthenticationToken,
	LOGIN_TWO_FACTOR_ACTION
} from "../actions/user-action-types";


import { wsDisconnectAction } from "../actions/socket-action-types";

import httpClient from "./http-client";
import { GetCurrentUserPermissions, GetUserPreferences, GetCurrentUserDictionary } from "./accounts";

function parseJwt (token) {
	//not used since token encryption
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var jsonPayload = decodeURIComponent(atob(base64).split('')?.map(function(c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	return JSON.parse(jsonPayload);
};

function* LoginAction({
	payload: { userName, password, history, callback = null },
}) {
	yield put(logoutSuccess());
	const payloadObj = {
		data: { userName, password },
		method: "post",
		url: "Account/Login",
	};

	const { error, result } = yield call(httpClient, payloadObj, true, false);

	if (
		error ||
		result?.status !== "Success" ||
		result?.message === "Password Invalid" ||
		!(result?.data)
	) {
		if (result?.status === "NotFound") {
			toast.error("Invalid credentials");

			if (callback) {
				callback({ error: "Invalid credentials" });
			}
		} 
		else 
		if (result?.status === "RequireEmailConfirm" || result?.status === "Require2fa") {
			if (callback) {
				callback({ result, error });
			}
		} else {
			toast.error(result?.message??result?.status??"Error while logging in");
		}
	} else {

		/*var parsedToken = parseJwt(result.data);
		const parsedTokenExpire = new Date(0);
		parsedTokenExpire.setUTCSeconds(parsedToken.exp);*/
		yield put(setAuthenticationToken({
			data: result.data, 
			tokenExpireDate: result.expireDate
		}));
		
		if (callback) 
			callback({ result, error });
	}
}

function* LoginTwoFactorAction({
	payload: { token, tokenExpireDate, callback = null },
}) {
		/*var parsedToken = parseJwt(token);
		const parsedTokenExpire = new Date(0);
		parsedTokenExpire.setUTCSeconds(parsedToken.exp);*/
		yield put(setAuthenticationToken({
			data: token, 
			tokenExpireDate: tokenExpireDate
		}));
		
		if (callback) 
			callback();
}

function* saveFilterHandler({ payload: { data, callback } }) {
	const payloadObj = {
		data: data,
		method: "post",
		url: "User/AddUpdUsrFilter",
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);
	if (error) {
	} else {
		yield getFiltersHandler({ payload: {  }});
	}
	if(callback)
	{
		callback({ result, error });
	}
}

function* LoadUser({ payload: { callback } }) {
	const returns = yield all([
		call(getUserHandler),
		call(GetCurrentUserPermissions),
		call(GetCurrentUserDictionary),
		call(GetUserPreferences),
	]);
	if (returns[1]?.error || !returns[1]?.result?.data?.length) {
		return toast.error(
			"Your account is not fully configured. Please contact your manager to complete the process."
		);
	}
	if(callback)
	{
		callback();
	}
}

function* getUserHandler() {

	const payloadObj = {
		method: "get",
		url: `Account/GetCurrentUser`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
		yield put(
			getUserSuccess({
				userInfo: result.data,
				status: "success",
			})
		);
		const user_id = result.data.id;

		yield getFiltersHandler({ payload: {  }});
	}
	return { error, result };
}

function* getFiltersHandler({ payload: { callback } }) {

	const currentUserId = yield select(
		({ session: { userInfo } }) => userInfo.id
	);

	const payloadObj = {
		method: "get",
		url: `User/GetUsrFilterByUserId?id=${currentUserId}`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
		yield put(
			getFiltersSuccess({
				filtersList: result.data,
				status: "success",
			})
		);
	}
	if(callback)
	{
		callback({ result, error });
	}
}

function* deleteFilterHandler({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "delete",
		url: `User/DeleteUsrFilter`,
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);
	if (error) {
	} else {
		yield getFiltersHandler({ payload: {  }});
	}
	if(callback)
	{
		callback({ result, error });
	}
}

function* LogOutAction({ payload: data }) {
	yield put(wsDisconnectAction());
	yield put(logoutSuccess({ requestLoginAgain: data?.requestLoginAgain }));
}

function* getTokenInternal({ payload: { tenantId, token, callback } }) {

	const payload = {
		data: { TenId: tenantId > 0 ? tenantId :  null },
		method: "post",
		url: "Account/RefreshToken",
		token: token
	};

	const { error, result } = yield call(httpClient, payload, true, true);

	if (callback) {
		callback({ error, result });
	}


	return { error, result };
}

function* updateJwtToken({ payload: { token, callback } }) {
	
	const { result, error } = yield call(getTokenInternal, { payload: { tenantId:0, token } });

	if (!error) {
		/*var parsedToken = parseJwt(result.data);
		const parsedTokenExpire = new Date(0);
		parsedTokenExpire.setUTCSeconds(parsedToken.exp);*/
		yield put(setAuthenticationToken({
			data: result.data, 
			tokenExpireDate: result.expireDate
		}));
	} else {
	}

	if (callback) {
		callback({ error, result });
	}

}


function* User() {
	yield all([
		takeLatest(LOGIN_ACTION, LoginAction),
		takeLatest(LOGIN_TWO_FACTOR_ACTION, LoginTwoFactorAction),
		takeLatest(LOAD_USER, LoadUser),
		takeLatest(LOGOUT_ACTION, LogOutAction),
		takeLatest(SAVEFILTER, saveFilterHandler),
		takeLatest(DELETE_FILTERS, deleteFilterHandler),
		takeLatest(UPDATE_JWT_TOKEN, updateJwtToken)
	]);
}

export default User;
